import React from 'react';
import '../notebooks/notebook.min.css';
import page404 from 'assets/img/404.png';
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Collapse,
  Table,
} from 'reactstrap';
import 'react-web-tabs/dist/react-web-tabs.css';
import StorageService from '../../services/api/Storage';
import axios from 'axios';
import { uuidv4, renderOutput } from 'components/Notebook/operations/notebook';

import MarkDown from 'components/Notebook/MarkDown';
import CodeHighlight from 'components/Notebook/CodeHighlight';
import 'c3/c3.css';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader';
import Scrollbars from 'react-custom-scrollbars';
import '../../assets/css/catalog.css';

class ViewCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      codeContent: '',
      myContentChart: '',
      fileName: this.props.fileName,
      fileType: '',
      renderNotebook: '',
      DownloadUrl: '',
      delimiter: ',',
      delimiterName: ',',
      chartName: '',
      chartCount: 0,
      chartArray: [],
      variableIncrement: 0,
      xyIncrement: 0,
      xyxscount: 0,
      xarray: [],
      yarray: [],
      variableNames: [],
      xyNames: [],
      chartHeader: [],
      selectChartHeader: '',
      selectchartType: 'line',
      wholeGraphData: [],
      totalPages: 0,
      activePage: 1,
      totalRecords: 0,
      showCode: false,
      openMark: [''],
      advanceicon: 'fas fa-plus-circle',
      markoptions: [],
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      storageId: '',
      rootFolder: '',
      storageName: '',
      platformDefault: false,
      errorFile: '',
    };
  }

  componentDidMount() {
    let ext = 'ipynb';
    if (this.state.fileName.endsWith(ext)) {
      this.downloadUrl(this.props?.fileName);
    } else {
      let fileName = this.props?.fileName.substring(
        0,
        this.props?.fileName.lastIndexOf('/')
      );
      let version = this.props?.fileName.substring(
        this.props?.fileName.lastIndexOf('/') + 1
      );

      this.downloadVersionUrl(fileName, version);
    }

    this.setState({ fileType: ext });
  }

  downloadUrl = (fileName) => {
    StorageService.downloadObjectUrl(
      fileName,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        this.renderText(response.download_url);
        this.setState({ DownloadUrl: response.download_url });
      })
      .catch((error) => {
        this.state.fileType = 'png';
        this.state.codeContent = page404;
        this.state.fileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  downloadVersionUrl = (fileName, version) => {
    StorageService.downloadVersionFilesUrl(
      fileName,
      version,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        this.renderText(response.download_url);
        this.setState({ DownloadUrl: response.download_url });
      })
      .catch((error) => {
        this.state.fileType = 'png';
        this.state.codeContent = page404;
        this.state.fileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  renderText = (url) => {
    this.setState({
      loading: true,
    });
    if (
      this.state.fileType == 'jpeg' ||
      this.state.fileType == 'jpg' ||
      this.state.fileType == 'png'
    ) {
      this.setState({
        codeContent: url,
        loading: false,
      });
    } else {
      axios.get(url).then((response) => {
        if (this.state.fileType == 'ipynb') {
          let notebook = response.data;
          this.setState(
            {
              loading: false,
            },
            () => {
              this.getNotebookCellsData(notebook);
            }
          );
        } else {
          this.setState({
            fileType: 'others',
            codeContent: response.data.toString(),
            loading: false,
          });
        }
      });
    }
  };

  getNotebookCellsData = (notebook) => {
    let options = [];
    let opencell = [];
    if (Array.isArray(notebook.cells)) {
      if (notebook.cells.length !== 0) {
        let count = 1;
        let contentid = 1;
        for (const notebookCell of notebook.cells) {
          if (!notebookCell.metadata.hasOwnProperty('decisionforce_cell_id')) {
            let metatab = { decisionforce_cell_id: uuidv4() };
            notebookCell.metadata = metatab;
          }
          if (notebookCell.cell_type === 'code') {
            notebookCell.metadata.codeindex = count++;
            opencell.push({
              name: notebookCell.metadata.decisionforce_cell_id,
            });
            this.state.opencellid = opencell;
          }
          if (notebookCell.cell_type === 'markdown') {
            if (typeof notebookCell.source === 'string') {
              if (notebookCell.source.substring(0, 20).includes('#')) {
                options.push({
                  name: notebookCell.source,
                });
                notebookCell.metadata.contentid = contentid++;
                this.setState({
                  markoptions: options,
                });
                this.state.markoptions = options;
              }
            }
            if (typeof notebookCell.source === 'object') {
              if (
                notebookCell.source[0].toString().substring(0, 20).includes('#')
              ) {
                options.push({
                  name: notebookCell.source[0],
                });
                notebookCell.metadata.contentid = contentid++;
                this.setState({
                  markoptions: options,
                });
                this.state.markoptions = options;
              }
            }
          }
        }
      }
      this.setState({
        codeContent: notebook.cells,
        loading: false,
      });
    }
  };
  collapsesMarkToggle = (collapse) => {
    let openMark = this.state.openMark;
    if (openMark.includes(collapse)) {
      this.setState({
        openMark: [],
      });
    } else {
      this.setState({
        openMark: [collapse],
      });
    }
  };
  callCode = (codevalue) => {
    if (codevalue === false) {
      this.expandMarkToggle();
    } else {
      this.closeMarkToggle();
    }
  };

  closeMarkToggle = () => {
    this.setState({
      openMark: [],
    });
  }
  
  expandMarkToggle = () => {
    let codelength = this.state.opencellid;
    let allcode = [];

    for (const cL of codelength) {
      allcode.push(cL.name);
    }
    this.setState({
      openMark: allcode,
    });
  };
  // Download particular file in input or code
  downloadparticularFiles = (fileName) => {
    StorageService.downloadObjectUrl(
      fileName,
      this.state.storageId,
      this.state.rootFolder
    ).then((response) => {
      const link = document.createElement('a');
      link.href = response.download_url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  render() {
    return (
      <LoadingOverlay
        active={this.state.loading}
        spinner={
          <ScaleLoader
            height={35}
            width={5}
            radius={2}
            margin={2}
            color={'#123abc'}
            loading={this.state.loading}
          />
        }
      >
        <Card>
          <CardHeader>
            <Row className='align-items-center'>
              <Col xs='8'>
                <Row className='row-class'>
                  <Col xs='12' className='p-0'>
                    <span
                      title={this.state.fileName}
                      className='overflowStyleNotebook p-0'
                    >
                      {' '}
                      &nbsp;&nbsp;File : {this.state.fileName}
                    </span>
                  </Col>
                </Row>
              </Col>
              {typeof this.state.codeContent !== "string" && <Col xs='2'>
                <div>
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ showCode: !this.state.showCode });
                      this.callCode(this.state.showCode);
                    }}
                    className='cursor-pointer'
                  >
                    <i
                      className={` ${
                        this.state.showCode
                          ? 'fas fa-minus-circle'
                          : 'fas fa-plus-circle'
                      } minus-plus-i`}
                    ></i>{' '}
                    <b className='bold-tag'>Code </b>
                  </span>
                </div>
              </Col>}
              {typeof this.state.codeContent !== "string" && <Col xs='2' className='text-right'>
                <i
                  className='fas fa-download df-text-primary fa-sm cursor-pointer'
                  onClick={(e) =>
                    this.downloadparticularFiles(this.state.fileName)
                  }
                ></i>
              </Col>}
            </Row>
          </CardHeader>
        </Card>
        <div className='carcontent'>
          <Row>
            <Col xs={2} className='carcontent-col'>
              {this.state.fileType === 'ipynb' && (
                <div>
                  <Scrollbars
                    autoHeight
                    autoHeightMin={this.state.sheight - 180}
                  >
                    <h5 className='h5-tag'>Table of Content</h5>
                    {this.state.markoptions !== '' ? (
                      this.state.markoptions?.map((itm, ind) => (
                        <Row className='cursor-pointer'>
                          <ol start={ind + 1}>
                            <li>
                              <div
                                onClick={() => this.scrollToNode(ind + 1)}
                                className={
                                  this.state.clickId === ind + 1
                                    ? 'activeLink markdiv'
                                    : 'markdiv'
                                }
                              >
                                <MarkDown markdownValue={itm.name}></MarkDown>
                              </div>
                            </li>
                          </ol>
                        </Row>
                      ))
                    ) : (
                      <div key={uuidv4()}></div>
                    )}
                  </Scrollbars>
                </div>
              )}
            </Col>
            <Col xs={10}>
              <div id='notebook-div'>
                {this.state.codeContent !== undefined && typeof this.state.codeContent !== "string" &&
                  this.state.codeContent.map((item, index) => {
                    return (
                      <div key={index} id={item.metadata.contentid}>
                        {/* if cell type is mark down */}
                        {item.cell_type === 'markdown' && (
                          <Row ref={(node) => (item.metadata.contentid = node)}>
                            <Col>
                              <div className='displaytxt'>
                                <Row className='align-items-center'>
                                  <div className='col-12 col-sm-9'>
                                    <MarkDown
                                      markdownValue={item.source}
                                      id={item.metadata.decisionforce_cell_id}
                                    ></MarkDown>
                                  </div>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        )}
                        {item.cell_type === 'code' && (
                          <div>
                            <div
                              aria-multiselectable={true}
                              className='card-collapse'
                              id='accordion'
                              role='tablist'
                            >
                              <a
                                aria-expanded={this.state.openMark.includes(
                                  item.metadata.decisionforce_cell_id
                                )}
                                href='#pablo'
                                data-parent='#accordion'
                                data-toggle='collapse'
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.collapsesMarkToggle(
                                    item.metadata.decisionforce_cell_id,
                                    this.state.openMark.includes(
                                      item.metadata.decisionforce_cell_id
                                    )
                                  );
                                }}
                              >
                                <Row className='align-items-center'>
                                  <div className='col-12 col-sm-10'>
                                    <div className='hrdiv'>
                                      <span className='hrtext'>Code</span>
                                    </div>
                                  </div>
                                  <div className='col-12 col-sm-2 text-right'>
                                    <span className='codetxt'>
                                      <button className='btn-icon btn-round btn btn-linkedin'>
                                        {item.metadata.codeindex}
                                      </button>
                                    </span>{' '}
                                    <i
                                      className={
                                        this.state.openMark.includes(
                                          item.metadata.decisionforce_cell_id
                                        ) === false
                                          ? 'fas fa-plus-circle'
                                          : 'fas fa-minus-circle'
                                      }
                                    ></i>
                                  </div>
                                </Row>
                              </a>
                              <Collapse
                                role='tabpanel'
                                isOpen={this.state.openMark.includes(
                                  item.metadata.decisionforce_cell_id
                                )}
                              >
                                <CardBody>
                                  <Row>
                                    <Col xs='12' className='row-col'>
                                      <div>
                                        <CodeHighlight
                                          codeValue={item.source}
                                          data={item}
                                          output={item.outputs}
                                          language={this.state.lang}
                                          flagId={this.state.codeFlag}
                                          index={index}
                                          _getNewCode={this._getNewCode}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Collapse>
                              {/* }  */}
                            </div>

                            <Row className='row-style'>
                              <div className='displaytxt'>
                                {item.outputs.length > 0 && (
                                  <div className='outputBorder'></div>
                                )}
                                {item.outputs.length > 0 && (
                                  <div className='displaytxt'>
                                    <pre>
                                      <code>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: renderOutput(item.outputs),
                                          }}
                                        ></div>
                                      </code>
                                    </pre>
                                  </div>
                                )}
                              </div>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {typeof this.state.codeContent === "string" &&
                      <img src={this.state.codeContent} alt="No Image" />}
              </div>
            </Col>
          </Row>
        </div>
      </LoadingOverlay>
    );
  }
}
export default ViewCode;
